import { Component, OnInit, ViewChild } from '@angular/core';
import { Table, TableModule, TableRowCollapseEvent, TableRowExpandEvent } from 'primeng/table';
import { ImageModule } from 'primeng/image';
import { CardModule } from 'primeng/card';
import { CommonModule } from '@angular/common';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { Router } from '@angular/router';
import { TagModule } from 'primeng/tag';
import { LambdaService } from 'src/app/services/lambda.service';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { MessageService } from 'primeng/api';


@Component({
  selector: 'app-stores',
  imports: [TableModule, CommonModule,  ImageModule,CardModule, IconFieldModule, InputIconModule, TableModule, InputTextModule, CommonModule, IconFieldModule, InputIconModule, ButtonModule, TagModule, ProgressSpinnerModule],
  templateUrl: './stores.component.html',
  styleUrl: './stores.component.scss'
})

export class StoresComponent implements OnInit{

  stores: any = [];
  loading = false;
  @ViewChild('dt') dt!: Table;
  expandedRows: { [key: string]: boolean } = { };

  constructor(private router: Router, private lambdaService: LambdaService, private messageService: MessageService) {}
  ngOnInit(): void {
    this.loadStores();
  }

  onRowExpand(event: TableRowExpandEvent) {
    // this.expandedRows = {};
    // this.expandedRows[event.data.shopId] = true;
    // console.log('event', event)
    // this.messageService.add({ severity: 'info', summary: 'Product Expanded', detail: event.data.name, life: 3000 });
  }

  onRowCollapse(event: TableRowCollapseEvent) {
    // delete this.expandedRows[event.data.shopId];
    // this.messageService.add({ severity: 'success', summary: 'Product Collapsed', detail: event.data.name, life: 3000 });
  }

  onInput(event: Event) {
    const input = event.target as HTMLInputElement; // Afirmación de tipo
    // console.log(input.value, "searching")
    this.dt.filterGlobal(input.value, 'contains'); // Usa el valor del input
  }

  loadStores(): void {
    this.loading = true;
    this.lambdaService.getShops()
    .then((data:any) => {
      // console.log("shops: ",data.data)
      this.stores = data.data;
    })
    .catch(error => {
      let errorMessage = 'Error al cargar las tiendas: ' + error;
      console.error(errorMessage);
    })
    .finally(()=>{
      setTimeout(() => {
        this.loading = false;
      }, 500);
    })
  }

  viewDetails(storeId: string) {
    this.router.navigate(['/store', storeId]);
  }

}
